import { SourceControlType } from '../types/quick-fix-types';

export const resolveSourceControlType = (appType: string) => {
  const sourceControlType = sourceControlMap[appType.toLowerCase()];

  return sourceControlType || null;
};

const sourceControlMap: Record<string, SourceControlType> = {
  github: SourceControlType.Github,
  gitlab: SourceControlType.Gitlab,
  'azure repos (git)': SourceControlType.Azure,
  bitbucket: SourceControlType.Bitbucket,
  stash: SourceControlType.Stash,
};
